import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { Element } from 'react-scroll';
import { propBool, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import SeminarOneFormAddButton from '../Parts/SeminarOneFormAddButton';
import SeminarOneFormDatesFieldArrayInner from './SeminarOneFormDatesFieldArrayInner';
const SeminarOneFormDatesFieldArray = (props) => {
    const { className, datepickerProps, disabled, mutators, name: fieldName, validates, } = props;
    /**
     * 「開催日時を追加」クリック時のイベント
     * @type {(function())|*}
     */
    const onClickAdd = useCallback(() => {
        mutators.push(fieldName, {});
    }, [fieldName, mutators]);
    return (_jsx(Element, Object.assign({ className: className, name: `${fieldName}_view` }, { children: _jsxs("div", Object.assign({ className: 'professional_seminar_one_form_dates' }, { children: [_jsx("div", Object.assign({ className: 'dates_rows' }, { children: _jsx(FieldArray, Object.assign({ name: fieldName }, { children: ({ fields }) => fields.map((name, index) => (_jsx(SeminarOneFormDatesFieldArrayInner, { className: 'dates_row', datepickerProps: datepickerProps, disabled: disabled, fields: fields, index: index, name: name, validates: validates }, name))) })) })), _jsx("div", Object.assign({ className: 'dates_add' }, { children: _jsx(SeminarOneFormAddButton, { className: 'add_button', disabled: disabled || disabled, onClick: onClickAdd, text: '開催日時を追加' }) }))] })) })));
};
SeminarOneFormDatesFieldArray.propTypes = {
    className: propStr(),
    datepickerProps: propShape().isRequired,
    disabled: propBool().isRequired,
    mutators: propShape().isRequired,
    name: propStr().isRequired,
    validates: propShape().isRequired,
};
SeminarOneFormDatesFieldArray.defaultProps = {
    className: '',
};
export default SeminarOneFormDatesFieldArray;
